import React from 'react'
import { ACCOUNT_BASE_URL } from '../common/js/site-config'

export default function App() {
    React.useEffect(() => {
        window.location.href = ACCOUNT_BASE_URL;
    }, [])

    return <></>
}
